// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listItem_DBGbE {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/screens/templates/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB","sourcesContent":[".listItem {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": `listItem_DBGbE`
};
export default ___CSS_LOADER_EXPORT___;
